import React, { useEffect, useState } from 'react';
import { Button, Typography, Progress, Space } from 'antd';
import { EnvironmentOutlined, ArrowRightOutlined, CloseOutlined } from '@ant-design/icons';
import api from '../../services/api';

const { Text } = Typography;
const BRAND = '#25D366';
const BRAND_DARK = '#128C7E';
const SNOOZE_KEY = 'profile_completion_snoozed_until';
const SNOOZE_DAYS = 3;

const GRID_BG =
  "url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='60' height='60' viewBox='0 0 60 60'><path d='M60 0H0v60' fill='none' stroke='rgba(255,255,255,0.08)' stroke-width='1'/></svg>\")";

function isSnoozed() {
  const t = parseInt(localStorage.getItem(SNOOZE_KEY) || '0', 10);
  return t && Date.now() < t;
}

export default function ProfileCompletionCard() {
  const [visible, setVisible] = useState(false);
  const [info, setInfo] = useState(null);

  useEffect(() => {
    if (isSnoozed()) return;
    (async () => {
      try {
        const r = await api.get('/community/players/profile-completeness');
        if (!r.data?.complete) {
          setInfo(r.data);
          setVisible(true);
        }
      } catch { /* silencioso */ }
    })();
  }, []);

  if (!visible || !info) return null;

  const snooze = () => {
    localStorage.setItem(SNOOZE_KEY, String(Date.now() + SNOOZE_DAYS * 24 * 60 * 60 * 1000));
    setVisible(false);
  };

  const pct = Math.round((info.filled_count / info.total) * 100);

  return (
    <div style={{
      position: 'relative', overflow: 'hidden',
      background: `linear-gradient(135deg, ${BRAND} 0%, ${BRAND_DARK} 100%)`,
      borderRadius: 20, padding: 20, color: '#fff',
      boxShadow: '0 8px 24px rgba(37,211,102,0.25)', marginBottom: 16,
    }}>
      <div style={{ position: 'absolute', inset: 0, backgroundImage: GRID_BG, opacity: 0.4 }} />
      <div style={{
        position: 'absolute', width: 200, height: 200, borderRadius: '50%',
        background: 'radial-gradient(circle, rgba(255,255,255,0.18) 0%, transparent 70%)',
        top: -80, right: -80,
      }} />

      <div style={{ position: 'relative', display: 'flex', gap: 14, alignItems: 'flex-start' }}>
        <div style={{
          width: 44, height: 44, borderRadius: 12, flexShrink: 0,
          background: 'rgba(255,255,255,0.18)', display: 'grid', placeItems: 'center',
          fontSize: 22,
        }}>📍</div>
        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{ fontSize: 17, fontWeight: 800, letterSpacing: -0.3, marginBottom: 4 }}>
            Bora completar seu perfil?
          </div>
          <Text style={{ color: 'rgba(255,255,255,0.9)', fontSize: 13, display: 'block', marginBottom: 12 }}>
            Falta pouco pra você achar times perto e receber convite dos organizadores.
          </Text>

          <div style={{ marginBottom: 14 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 4 }}>
              <Text style={{ color: 'rgba(255,255,255,0.85)', fontSize: 12 }}>
                {info.filled_count} de {info.total} campos
              </Text>
              <Text style={{ color: '#FFE066', fontSize: 12, fontWeight: 700 }}>{pct}%</Text>
            </div>
            <Progress
              percent={pct}
              showInfo={false}
              strokeColor="#FFE066"
              trailColor="rgba(255,255,255,0.2)"
              size="small"
            />
          </div>

          <Space wrap>
            <Button
              type="primary"
              icon={<ArrowRightOutlined />}
              onClick={() => { window.location.href = '/player/profile'; }}
              style={{
                background: '#fff', color: BRAND_DARK, borderColor: '#fff',
                fontWeight: 700, height: 38, borderRadius: 10,
                boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
              }}
            >
              Completar agora
            </Button>
            <Button
              type="text"
              icon={<CloseOutlined />}
              onClick={snooze}
              style={{ color: 'rgba(255,255,255,0.85)', fontWeight: 500, height: 38 }}
            >
              Depois
            </Button>
          </Space>
        </div>
      </div>
    </div>
  );
}
